import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: { "width": "var(--top-personal-btn-font-size)", "height": "var(--top-personal-btn-font-size)", "min-width": "var(--top-personal-btn-font-size)", "min-height": "var(--top-personal-btn-font-size)" }
};
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TopPersonalBtn',
    setup: function (__props) {
        var store = useStore();
        var router = useRouter();
        var options = [
            {
                label: "个人中心",
                key: "personal-center",
                // icon: () => h(NIcon, null, { default: () => h(BookmarkOutline) }),
                onClick: function () {
                    window.$message.info("个人中心建设中");
                },
            },
            {
                key: "header-divider",
                type: "divider",
            },
            {
                label: "设置",
                key: "setting",
                onClick: function () {
                    window.isConfigDrawerActive.value = true;
                },
            },
            {
                key: "header-divider",
                type: "divider",
            },
            {
                label: "退出登陆",
                key: "logout",
                onClick: function () {
                    api.request.post("/logout").then(function (res) {
                        window.$message.info("退出登陆");
                        router.push({ name: "login" });
                    });
                },
            },
        ];
        function handleSelect(key) {
            console.log("handleSelect", key);
            var seletedOption = options.find(function (option) { return option.key === key; });
            if (seletedOption && typeof seletedOption.onClick === "function") {
                seletedOption.onClick();
            }
        }
        return function (_ctx, _cache) {
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_dropdown = _resolveComponent("n-dropdown");
            return (_openBlock(), _createBlock(_component_n_dropdown, {
                trigger: "hover",
                options: options,
                onSelect: handleSelect,
                size: "medium"
            }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_n_button, {
                        quaternary: "",
                        class: "top-personal-btn",
                        style: { "--top-personal-btn-font-size": "1.6rem" }
                    }, {
                        icon: _withCtx(function () { return [
                            (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
                                _createElementVNode("g", {
                                    fill: "none",
                                    stroke: "var(--font-color)",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                }, [
                                    _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "9"
                                    }),
                                    _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "10",
                                        r: "3"
                                    }),
                                    _createElementVNode("path", { d: "M6.168 18.849A4 4 0 0 1 10 16h4a4 4 0 0 1 3.834 2.855" })
                                ], -1)
                            ])))
                        ]; }),
                        default: _withCtx(function () { return [
                            _cache[1] || (_cache[1] = _createTextVNode(" 清蒸QB "))
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            }));
        };
    }
});
